import "../../styles/vars.scss";
import "../../styles/main.scss";
import "../../styles/compo.scss";
import SvgIcn from "../../data/IconCompo";

function TopCardStaticP ({ icon, title, text, to, children, clickable, color, className }) {
  const cardClass = `top-card-static ${clickable ? 'clickable' : ''} ${color || 'g_04'} ${className || ''}`;

  return (
    <div 
      className={cardClass}
      onClick={clickable ? () => window.location.href = to || "#" : undefined}
    >
      {icon && <SvgIcn name={icon} className="card-icon"/>}
      {title ? <h2>{title}</h2> : null}
    
      {children}
    </div>
  );
} 

export default TopCardStaticP;
